import React, { Component } from 'react'
import { 
  Card, 
  CardHeader, 
  CardBody, 
  Badge, 
  CardFooter, 
  Button, } from 'reactstrap'
import TextEditor2 from '../TextEditor/TextEditor2'
import alphaNum from '../../helpers/alphaNum'
import alphaNumF from '../../helpers/alphaNumF'
import { AnswersHtmlEditor } from './ManageContentComponents'

class AnswerChoiceEditor extends Component {
  state = {
    content: this.props.quillText + '',
    error: '',
    wysiwyg: false,
  }

  toggleWysiwyg = () => this.setState({wysiwyg: !this.state.wysiwyg})
  
  render() {
    const { 
      correctChoiceQ,
      startingLetter,
      cardIndex,
      colorScheme,
      handleClickThumb,
      handleDeleteAnswerChoice,
      activeEdit,
      quillText,
      handleQuillChange,
      answers,
      toggleActiveEditor,
      copyFeedback,
      saving,
      handleClickSave,
    } = this.props
    const { wysiwyg } = this.state
    const { toggleWysiwyg } = this

    let correctHeader = {}
    correctChoiceQ ? correctHeader.icon = 'like' : correctHeader.icon = 'dislike'
    correctChoiceQ ? correctHeader.text = 'Correct Choice' : correctHeader.text = 'Incorrect Choice'
    let letter = ''
    if (startingLetter === 'a' && cardIndex <= 6) {
      letter = `(${alphaNum[cardIndex]})` 
    } else if (startingLetter === 'f' && cardIndex <= 6) {
      letter = `(${alphaNumF[cardIndex]})`    
    }
  
    return (
      <Card className={'card-accent-' + colorScheme}>
        <CardHeader>
          <i 
            className={"icon-" + correctHeader.icon + " icons font-1xl mt-2 m2clickable"}
            onClick={() => handleClickThumb(cardIndex, !correctChoiceQ)}
            ></i>{correctHeader.text}{' '}{letter}
          <Badge 
            color="danger" 
            className="float-right m2clickable" 
            onClick={(e) => handleDeleteAnswerChoice(e, cardIndex)}
          >
            Delete
          </Badge>                           
        </CardHeader>
        <CardBody className='card-body'>
          {activeEdit.type === 'answer' && activeEdit.index === cardIndex
            ? wysiwyg 
              ? <TextEditor2
                  editorId={{type: 'answer', index: cardIndex}} 
                  quillText={quillText}
                  handleQuillChange={handleQuillChange}
                />
              : <AnswersHtmlEditor
                  contents={quillText}
                  handleChange={handleQuillChange}
                  contentType='answer'
                />
            : <div 
                dangerouslySetInnerHTML={{__html: answers[Number(cardIndex)]&& answers[Number(cardIndex)].answer ? answers[Number(cardIndex)].answer : 'Add answer here...' }}
                onClick={(e) => toggleActiveEditor(e, {type: 'answer', index: cardIndex})}></div>
          }
        </CardBody>
        <CardHeader onClick={(e) => {
          (activeEdit.type !== 'feedback' || activeEdit.index != cardIndex) &&
          toggleActiveEditor(e, {type: 'feedback', index: cardIndex})
        }}>
          <i className="icon-speech icons font-1xl mt-2"></i>Feedback                 
        </CardHeader>
        <CardBody className='card-body'>
          {activeEdit.type === 'feedback' && activeEdit.index === cardIndex
            ? wysiwyg
              ? <TextEditor2
                  editorId={{type: 'feedback', index: cardIndex}} 
                  quillText={quillText}
                  handleQuillChange={handleQuillChange}
                />
              : <AnswersHtmlEditor
                  contents={quillText}
                  handleChange={handleQuillChange}
                  contentType='feedback'
                />
            : <div 
                dangerouslySetInnerHTML={{__html: answers[Number(cardIndex)] && answers[Number(cardIndex)].feedback ? answers[Number(cardIndex)].feedback : 'Add feedback here...' }}
                onClick={(e) => toggleActiveEditor(e, {type: 'feedback', index: cardIndex})}></div>
          }
        </CardBody>
        <CardFooter>
          <Button onClick={toggleWysiwyg}>
            {wysiwyg
              ? 'Edit HTML'
              : 'Edit WYSIWYG'
            }
          </Button>
          <Button 
            onClick={() => copyFeedback(answers[Number(cardIndex)].feedback || '')}
          >
            Copy Feedback
          </Button>
          <Button
            onClick={handleClickSave}
            disabled={saving}
          >
            {saving ? 'Saving' : 'Save'}
          </Button>
        </CardFooter>
      </Card>
    )
  }
}

export default AnswerChoiceEditor


// WEBPACK FOOTER //
// ./src/components/Content/AnswerChoiceEditor.js